export default {
	methods: 
    {	
		async watchAfiliado()
		{
			await this.updateCrud({state: 'dataMultiple/'+this.namePath+'/multiple_servicios',data: this.predeterminados[this.namePath].multiple_servicios})
			this.editarDataPost=true

			let valorServicios =  await this.getData({route: 'get_afiliado_servicios', data:  this.searchSw.value })

			await this.updateDataForm({state: 'servicios_inits', data: valorServicios['servicios_inits']})
			await this.updateDataForm({state: 'servicios_activos', data: valorServicios['servicios_activos']})

			for (let i = 0; i < valorServicios['servicios_nuevos'].length; i++) {
				
				let indexActivo=_.findIndex(valorServicios['servicios_activos'], ['name',valorServicios['servicios_nuevos'][i].name])
				if(indexActivo===-1)
				{
					await this.pushDataForm({state: 'servicios_activos', data: valorServicios['servicios_nuevos'][i]})
				}								
			}

			await this.updateDataForm({state: 'datos_afiliado', data: valorServicios['datos_afiliado']})
			await this.updateDataForm({state: 'info_afiliacion', data: valorServicios['info_afiliacion']})

		}	
	},
}